<template>
<div class="chapter">
<div class="inner_page">
<p class="SWchapter" id="calibre_pb_3">CHAPTER ONE</p>
<p class="c3"><a id="Chapterone"></a> You see it
all started a few nights ago in southern Florida.</p>
<p class="western">I was sitting on a white sofa in a swanky
modern beach house that is owned by an incredibly gorgeous
dark-haired man who was reclining on a matching sofa opposite me.
My brother-in-law, Cole, sat in a white chair between the
couches.</p>
<p class="western">When we arrived in this home an hour before,
the homeowner, Stefano, offered us cocktails (“Sharkbites,” if you
can believe it), and changed into a pair of black silk pajama pants
and a black tank top. His hair is just about as black as his
clothes, and he has the kind of tan skin that makes you wonder if
he was born with it or if it’s a gift from the sun. He was
barefooted, and I noticed that he was well pedicured. Something
about him told me that his feet probably didn’t even stink. Looking
him over on the sofa, I realized that I should’ve been attracted to
him and that most people he meets probably go ape shit over him in
a matter of minutes, but only a few hours before he had been
married to my nephew, and I realized he’s one of those guys.</p>
<p class="western">I know, I know. I shouldn’t judge people,
but if you were a gay man my age, you would know exactly what I
mean by, <i class="calibre1">one of those guys</i>. He’s the kind of guy who has
lived long enough that he appears to have his shit together. Then
you see him walking arm-in-arm with a guy half his age, and you
realize he’s one of those guys.</p>
<p class="western">Don’t get me wrong, I am all about live and
let live, I just don’t allow myself to get attracted to those kind
of men. Guys like him are the reason that I quit dating.</p>
<p class="western">“Are you all hungry?” he asked. “I’m pretty
good in the kitchen.”</p>
<p class="western">I imagined that he was, and I also imagined
that he was pretty good in the bedroom, but I preferred not to test
him in either location. Unfortunately, I was hungry. Really hungry.
I just didn’t want to tell him that.</p>
<p class="western">“I could eat,” I answered, trying to sound
as nonchalant as possible.</p>
<p class="western">“I’m starved,” Cole said, rising from his
chair with a smile. “We didn’t get to really finish our meals back
at the restaurant.”</p>
<p class="western"> <br class="calibre2"/></p>
<p class="c1">***</p>
<p class="western"> <br class="calibre2"/></p>
<p class="c3">There’s a rumor that stories about my nephews have
been getting out lately—really intimate stuff about their lives
written down for everyone to read. Hearing that I thought, <i class="calibre1">Did
the boys really write all this down? After all, Logan is a wannabe
novelist.</i> Of course, I didn’t want to ask them, but I thought,
<i class="calibre1">What the hell? I’ve got a story worth telling.</i> Looking at
what you’ve read so far, I guess that like my nephews, I kind of
get ahead of myself sometimes. In case you haven’t heard those
stories about my nephews, let me briefly explain how I ended up in
this beach house in the first place.</p>
<p class="western">You see, it all started with my
brother-in-law. I can’t say no to him. I couldn’t when he was my
commanding officer, and I can’t now. It’s not only that he’s
gorgeous, and even at fifty plus looks like the young dad in a
wholesome TV drama. It’s not just because I used to fantasize about
him from time to time when we were stationed on a small island in
the middle of nowhere. Aside from those things, it’s also because
his wife just died a few years ago, and he has managed to carry on
like a trooper. We were both crazy in love with my sister, just in
entirely different ways. I should also mention that I am a sucker
for his two kids, my only nephews, who both happen to be involved
in this story I am about to tell. It also might have something to
do with the fact that long before Cole was my brother-in-law, he
was also my mentor, and at a time when I really needed one, my best
friend.</p>
<p class="western">When Cole called me over a year ago to tell
me that my nephew Sam had been accepted into Suncoast University’s
School of Law, and would be attending on a full scholarship, I was
proud. When Cole called to tell me that Sam was moving in with two
male-model looking billionaire twins in a beach house so they could
live in domestic and romantic bliss, I bragged to my friends for
weeks. As you can imagine, Cole felt a little differently.</p>
<p class="western">That’s why he sent Logan, Sam’s little
brother, to Suncoast—to straighten Sam out. When he told me that, I
laughed hysterically. I love me some Logan, but he would not be on
the SWAT Team I would send in to rescue people who I thought were
ruining their lives. In those situations, Logan has usually been
the one being rescued, and oftentimes, it’s by Sam.</p>
<p class="western">To make a long story short, the whole thing
got really wild, really fast. Cole called me the morning that Logan
went off to Shark Beach a little happy, a little worried. About a
week later he called me again. This time, he was frantic.</p>
<p class="western">“Oh, my God, Mark. I have got to talk to
you,” Cole said, in that voice he never used in front of his
children, the one that I imagine he had used only with Emily,
myself, and a handful of other people around whom he let down his
guard.</p>
<p class="western">“Good, because I’ve got to talk to you too,”
I said, slowly sipping my second cup of coffee. I had spit out most
of my first cup of coffee during the first call I had received that
morning. “What’s going on, Cole?”</p>
<p class="western">“Well, Sam just called me. He wanted to
invite me to a dinner to celebrate Logan’s wedding. It seems he got
married last night.”</p>
<p class="western">“Damn it, Cole!” I shouted. “That’s the
second cup of coffee I’ve spit out this morning.”</p>
<p class="western">“Well don’t drink anymore until I finish the
story,” he said.</p>
<p class="western">“Okay, let’s hear the rest of it,” I said,
placing my coffee cup down, and slowly wiping the kitchen counter
and floor, grateful that I had bought extra absorbent paper
towels.</p>
<p class="western">“He married a man,” Cole said.</p>
<p class="western">“Fuck,” I mumbled. “I guess I should be
proud that both of your children seem to be taking after me, but I
can see why you might be upset.”</p>
<p class="western">“No, Mark, I have had my suspicions about
Logan, and so it’s fine if he’s gay. I was upset about Sam because
I never saw that coming. Hell, the way Logan and his friend Tom
look at each other I always thought that, well, you get it, but
that’s not what happened. He didn’t marry his young friend Tom. He
married a man. A grown-up with a career. Sam said he owns a
restaurant. That’s where I’m supposed to have dinner with Sam and
his guys, boys, lovers, whatever the hell they are, and then I get
to meet the old fuck that married my youngest son last night. Did I
mention that Logan’s friend, Tom, will be there? You know, the one
that I think is in love with Logan. I can’t imagine a more awkward
family dinner, and you’ve met my parents,” Cole said, a tension in
his voice that I wasn’t used to hearing.</p>
<p class="western">“Wow!” I replied, unsure of what to say
next. “It sounds like you’re going to have quite an evening.”</p>
<p class="western">“I was hoping that <i class="calibre1">we</i> could have
quite an evening,” he announced, with an odd mixture of confidence
and desperation, and then the sad voice. “Will you join me?”</p>
<p class="western">“Well, I…”</p>
<p class="western">“Please, Mark,” he said, all desperation
now. “I’m really worried that I’m going to screw this up.”</p>
<p class="western">I heard the question, but I heard so much
more. This was the request of a man who didn’t want to lose his
children. He had lost so much in the last few years, and things in
the lives of his sons had not gone anywhere near to where he
thought they might.</p>
<p class="western">“It’s just that I’m not very diplomatic when
it comes to my boys. I want what’s best for them whether they know
it or not. Emily would know how to handle this, and I just don’t,”
he continued. “If you could help me out, Mark…”</p>
<p class="western">“I’ve got you, man,” I said. “I’ve got you,
Cole. What time do you want me there?”</p>
<p class="western">“I had hoped that’s what you’d say. Your
flight leaves BWI a little after noon. I’ll pick you up at the
Tampa airport, and we can drive to Shark Beach together,” he said,
his confidence back.</p>
<p class="western">“Well that means I should try to get to the
airport by ten. I need to shower and pack. How long are we
staying?”</p>
<p class="western">“I’m not sure, Mark. Do you have a few
days?”</p>
<p class="western">“A few weeks, actually. I don’t have to
teach until then,” I said, trying to sound reassuring.</p>
<p class="western">“Great, I doubt we’ll be there long, but
just in case,” Cole said.</p>
<p class="western">“Just in case is right,” I agreed. “If
things tonight are half as interesting as they have been then we
should plan on extra time. By the way, Cole, have you told
them?”</p>
<p class="western">“No,” he said. “I mean, as far as I know
there hasn’t been any need, but maybe this other stuff ties into it
all somehow.”</p>
<p class="western">“Maybe,” I said. “Sometimes kids have a way
of finding things out that you didn’t plan on telling them.”</p>
<p class="western">“They do,” Cole agreed. “If they have to
find out though, I want to be the one to tell them, but maybe it’s
too late for that. By the way, what happened to the first cup of
coffee?”</p>
<p class="western">“Long story,” I said. “One that I’ll tell
you when you pick me up from the airport. For now, let’s just say
that you’re not the only one who got a shocking phone call this
morning.”</p>
<p class="western">“Who was yours from?”</p>
<p class="western">“Olivia,” I said. “Remember, Olivia?”</p>
<p class="western">“Isn’t that the woman from twenty years ago
who...?”</p>
<p class="western">“That’s her. Look, I’ll tell you all about
it tonight. I can use some serious advice.”</p>
<p class="western">“Got you,” Cole said.</p>
<p class="western">“Thanks, man,” I mumbled. “I better go
now.”</p>
<p class="western">“Yeah,” Cole agreed. “We both need to be
prepared for this evening.”</p>
<p class="western"> <br class="calibre2"/></p>
<p class="c1">***</p>
<p class="western"> <br class="calibre2"/></p>
<p class="c3">In retrospect, I think there was very little we could
have done to prepare for that night. Cole drove down from Northern
Florida and picked me up on time from the Tampa airport. We both
looked good—button up shirts, nice slacks, jackets but no ties. We
were aiming for tasteful without being intimidating—we were on the
same page. In the car, he listened as I went on and on about my
little, well I guess it is now actually a pretty large, situation,
shall we say, and I reminded him to stay calm no matter what
transpired at dinner.</p>
<p class="western">When we got to the restaurant, Sam and his
partners were already waiting for us in the parking lot. By the
way, his partners, Derek and Wyn, were breathtaking. Extremely
breathtaking for guys their age, but they were also super polite
and well-mannered. There was one little thing about them though
that caught us by surprise.</p>
<p class="western">“Does Sam know?” I asked Cole in a whisper,
as I pretended to straighten his collar.</p>
<p class="western">“I don’t think so,” he whispered back.</p>
<p class="western">We gave each other questioning looks as we
followed a startlingly attractive dark-haired woman from the
hostess stand.</p>
<p class="western">“I’m Stefano’s sister, Stefani. I’m so sorry
you couldn’t make the ceremony last night, but I just want you to
know how glad I am that you’re here,” the woman said, directing us
to a table that it seemed she had chosen just for us. “We have a
little show planned for this evening. Enjoy.”</p>
<p class="western">“Does <i class="calibre1">she</i> know?” I asked Cole again
in a whisper, after she had left.</p>
<p class="western">“I don’t think so,” he said. “There’s
something up with her though.”</p>
<p class="western">Our table was by a large aquarium that went
through the ceiling and I imagined up several floors. Within
fifteen minutes Cole seemed relaxed. We were all enjoying some
really good soup when a rather large shark cage came sinking down
in the aquarium and landed on the bottom really close to the glass
near our table. Inside was Logan, and Tom, his friend, the one that
Cole was sure was in love with Logan, both in scuba gear.</p>
<p class="western">We were ready to be entertained, but when we
saw two bull sharks circling above the cage, we weren’t so sure.
Cole and I looked at each other. At about the same time, we both
realized that the cage was open on top.</p>
<p class="western">“I guess this is part of the show,” Sam
said, uncertainty in his voice.</p>
<p class="western">“I don’t think so,” Cole replied, rising
from his chair. “If it is, I don’t think it’s a show we want to
watch.”</p>
<p class="western">“Stephani is really not a nice person,”
Derek said, standing.</p>
<p class="western">“Fucking asshole is more like it,” Wyn
added, joining his brother.</p>
<p class="western">We all nodded, pretty sure that Wyn was
right. Derek and Wyn ran to a nearby set of stairs while Sam
grabbed a chair and slammed it as hard as he could against the
aquarium wall. We heard gasps from the people around us, and then a
few chuckles that assured us that they were much more aware of what
was going on than we were.</p>
<p class="western">Cole walked quietly to the glass aquarium
wall. I followed close behind.</p>
<p class="western">“He can do this. He can get out of this,”
Cole said, looking at me.</p>
<p class="western">“Of course he can,” I said, hoping to
reassure us both.</p>
<p class="western">“He did it when he was a baby. He can do it
again,” Cole said. “I’m his father. I will get him through
this.”</p>
<p class="western">I nodded at Cole and patted him on the
shoulder. He stood in front of the glass and I stood next to him.
He reached his hand to the glass and Logan reached his hand up to
meet his father’s.</p>
<p class="western">“You can do this. You can do this,” Cole
said, his voice calm and confident even as he tried to shout
through the glass.</p>
<p class="western">Logan nodded. That was about the time that
he made us both proud. Air bubbles began to fill the water around
him, and Logan burst out of that cage like nobody’s business. He
had changed into a great white that looked a whole lot like Cole
did at that age. Sam looked more than a little surprised and it
took a few minutes for Tom to catch on as Cole tried to explain the
situation to him through the glass.</p>
<p class="western">As you might imagine, the bull sharks were
surprised too. Actually, they were so surprised that after Logan
chased them around a bit, they rushed to the top and changed back
to their human form. As Sam, Cole, and I found our way up to the
top of the aquarium on the third floor of the building, Derek and
Wyn were reviving a handsome guy in business clothes. He was about
my age, and I have to admit I was a little interested. Well, I was
interested until Derek introduced him as Stefano.</p>
<p class="western">It took about an hour to sort through the
whole sordid mess, which included filling Logan and Sam in on the
fact that their father was a shark shifter. Logan seemed pretty
thrilled. I mean, who wouldn’t be if they found out that they could
protect their loved ones by turning into a great white shark? Sam
on the other hand, the kid who always does what he is supposed to,
and usually gets rewarded for it, and who happens to be rather
amorously living with two shark shifters, was not as thrilled.</p>
<p class="western">It started him wondering why he had never
turned into a great white. This led us to inform him that although
his father was a great white, that his mother and I were both
dolphins, and that sometimes, mingled shifter couples didn’t always
produce shifter offspring. We thought he’d be happy to know that
his father was much cooler about him living with two guys since I
had reminded Cole that dolphins did this sort of things sometimes,
but to Sam I think that made Cole look like a closed-minded father
who generalized too much. Then Derek and Wyn let it slip that their
mother would be pissed that they were involved with a dolphin.
That’s when Sam decided that he and his lovers needed to move out
of the gorgeous beach house they were living in because he didn’t
want to accept anything from people who thought that way. It wasn’t
a really great night for Sam.</p>
<p class="western">It also wasn’t a great night for Stefano.
You see, this whole thing started when Sam, Derek, and Wyn more or
less tripped their way into a shiver war with the shiver that
Stefano was leading. Stefano, being who he was, had fallen for
Logan and come right out and married him. That was great for Sam
and company, because Stefano said he and his group would no longer
seek any retribution from Sam, Derek, and Wyn. It wasn’t so great
for Tom and Logan though, because as Cole had figured out before
they had figured it for themselves, they were in love. Of course,
when they did finally come to terms with it, Stefano’s evil sister,
Stefani, was there to catch them between the sheets. And while
Stefano was away on business today, Stefani managed to get their
entire shiver to vote Stefano out as shiver leader, and vote her
in. She also managed to invite a bunch of people to watch my nephew
and his friend get eaten by sharks, but luckily for us that had
never happened. The show was now over, and Logan and Tom were
okay.</p>
<p class="western">Stefani, as you might imagine, was not.
After loudly denouncing his marriage to Logan, which in old shark
customs served as a divorce, Stefano told his sister and her
flunkies to get out of his restaurant. Stefani said she was his
shiver leader and would do what she wanted. Stefano then denounced
the shiver, as did the two bull sharks who were pissed at Stefani
for putting them in the tank with a great white. As she left,
Stefani looked like she was about to cry, something I am not sure
she had ever really done before, except perhaps for attention.
Derek and Wyn had similar looks when Sam threatened to withhold sex
if they didn’t move out of the beach house, and then somehow or
another Cole and I volunteered ourselves to watch over Stefano,
which meant staying at his house for a few days with the hopes that
no one from this shiver he had just quit would mess with him if a
great white and a dolphin had his back.</p>
<p class="western">I don’t want to say that the night was a
disaster, I mean, there were a lot of things we got cleared up, but
let’s just say that as strange as it was, I was glad Cole hadn’t
gone alone. Not to mention, Cole was right. It was even worse than
Thanksgiving with his parents.</p>
<p class="western">Logan and Tom headed off to the hotel-type
apartment that Cole had rented for Logan when he sent him to Shark
Beach. Sam and the twins went back to their house, with Sam
swearing that they would be looking for a new place in the morning,
and Cole and I followed Stefano to what even in the dark appeared
to be an incredible looking beach house.</p>
<p class="western">There were two gates around the house. One
you passed through initially as you exited the road and entered the
property, and the other one surrounded the pool and the house. If
we had to do guard duty, then this had a much better set up than
most places.</p>
<p class="western">And so that’s how we ended up here—Cole and
I, sitting in some designer beach house in Shark Beach, with some
fantastic looking man offering us food.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?5d65f5f9